import React, { Component } from 'react'
import DataTable from 'react-data-table-component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faTrash, faUser } from '@fortawesome/free-solid-svg-icons';
import AddUser from './AddUser';
import AssignUser from './AssignUser';
import ToastComp from '../../../components/Toast/Toast';
import axios from 'axios';
import { API } from '../../../config/API';
import Loader from '../../../components/Loader/Loader';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import './User.css';
import toast from 'react-hot-toast';

export default class User extends Component {

  constructor() {
    super();
    this.columns = [
      {
        id: "id",
        name: 'ID',
        selector: row => row.id,
        width: '80px'
      },
      {
        name: 'NAME',
        selector: row => row.name,
      },
       {
                name: 'ROLE',
                selector: row => row.role,
            },
      {
        name: 'EMAIL',
        selector: row => row.email,
      },
      {
        name: "EMP ID",
        selector: row => row.username,
        width: '110px'
      },
      {
        name: 'DEPARTMENT',
        selector: props => this.formatDepartment(props.groups),
      },

      {
        cell: (row) => {
          const disabled = row.role === 'ADMIN';
          return (
            <button
              id={row.id}
              className={'btn btn-info' + (disabled ? ' disabled' : '')}
              onClick={() => !disabled && this.editUser(row)}
              disabled={disabled}
              title={disabled ? 'Edit disabled for ADMIN' : 'Edit'}
            >
              <FontAwesomeIcon icon={faEdit} className='table-icon-inline' />EDIT
            </button>
          );
        },
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
      },
      {
        cell: (row) => {
          const disabled = row.role === 'ADMIN';
          return (
            <button
              id={row.id}
              className={'btn btn-danger' + (disabled ? ' disabled' : '')}
              onClick={() => !disabled && this.deleteUser(row.id)}
              disabled={disabled}
              title={disabled ? 'Delete disabled for ADMIN' : 'Delete'}
            >
              <FontAwesomeIcon icon={faTrash} className='table-icon-inline' />DELETE
            </button>
          );
        },
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
      },
      {
        cell: (row) => <button id={row.id} className='btn btn-warning' onClick={() => this.assignUser(row.id)}> <FontAwesomeIcon icon={faUser} className='table-icon-inline' />ASSIGN</button>,
        ignoreRowClick: true,
        allowOverflow: true,
        button: true,
      },
    ];
    this.state = {
      data: [],
      fullData: [],
      toggleForm: false,
      toggleAssign: false,
      deleteAlert: false,
      editForm: false,
      loader: false
    }
    this.individualUser = {};
    this.levelData = [];
    this.projectData = [];

  }
  formatDepartment = (group) => {
    if (group && group.length) return group[0].name;
    return "";
  }
  addUser = () => {
    this.setState({ toggleForm: true });
  }
  updateToggleFormVal = () => {
    this.setState({ toggleForm: false });
  }
  updateToggleAssign = () => {
    this.setState({ toggleAssign: false })
  }
  assignUser = (id) => {
    this.individualUser = id;
    this.setState({ toggleAssign: true })
  }
  deleteUser = (id) => {

    // Show the confirmation dialog
    confirmAlert({
      message: 'Are you sure you want to delete this user?',
      buttons: [
        {
          label: 'YES',
          className: 'btn btn-success',
          onClick: () => {
            // If "OK" is clicked, proceed with the delete operation
            // Put your delete logic here
            console.log('Delete operation confirmed!');
            this.setState({ loader: true });
            axios.post(API.deleteUser, { id }).then((resp) => {

              if (resp.status) {
                // this.setState({ deleteAlert: true });
                toast.success('User deleted successfully.');
                this.loadUserList();
              } else {
                this.setState({ loader: false });
              }
            }).catch((er) => {
              this.setState({ loader: false });
            });
          },
        },
        {
          label: 'CANCEL',
          className: 'btn btn-error',
          onClick: () => {
            // If "Cancel" is clicked, do nothing
            console.log('Delete operation cancelled!');
          },
        },
      ],
    });

    ////


  }
  editUser = (data) => {
    console.log(data);
    this.individualUser = data;
    this.setState({ editForm: true });
  }
  updateToggleEdit = () => {
    this.setState({ editForm: false });
  }
  loadUserList = () => {
    this.setState({ toggleForm: false });
    this.setState({ editForm: false })
    this.setState({ loader: true });
    axios.get(API.listUser).then((resp) => {
      if (resp.status === 200 && resp.data) {

        // Exclude super admin users
        const filteredUsers = resp.data.users.filter(user => user.role !== 'SUPER_ADMIN');
        this.setState({ data: filteredUsers });
        this.setState({ fullData: filteredUsers });
      }
    }).catch((er) => {
    }).finally(() => {
      this.setState({ loader: false });
    })
  }

  loadMasterData = () => {
    this.setState({ loader: true });
    axios.get(API.getUserMasterData).then((resp) => {
      if (resp.status === 200 && resp.data) {
        this.levelData = resp.data.levels;
        this.projectData = resp.data.projects;
        //List users
        this.loadUserList();
      }
    }).catch((er) => {
    }).finally(() => {
      //this.setState({loader:false});
    })
  }
  componentDidMount() {
    //load master data-list of level&project
    this.loadMasterData();
  }
  //search by emp id
  filterDatabyID = (e) => {
    const key = e.target.value;
    let ar = [];
    this.state.fullData.forEach(element => {
      if (element.username.toLowerCase().indexOf(key.toLowerCase()) > -1)
        ar.push(element);
    });
    this.setState({ data: ar })
  }

  //Search fn
  filterData = (e) => {
    const key = e.target.value;
    let ar = [];
    this.state.fullData.forEach(element => {
      if (element.name.toLowerCase().indexOf(key.toLowerCase()) > -1)
        ar.push(element);
    });
    this.setState({ data: ar })
  }

  render() {
    const masterData = {
      level: this.levelData,
      project: this.projectData
    };
    return (
      <div>
        <Loader loading={this.state.loader}></Loader>
        {this.state.editForm ? <AddUser masterData={masterData} callback={this.loadUserList} userlist={this.state.fullData} user={this.individualUser} edit={true} handler={this.updateToggleEdit} flag={this.state.editForm ? true : false} /> : ''}
        {this.state.deleteAlert ? <ToastComp case='delete' handler={() => { this.setState({ deleteAlert: false }) }} /> : ""}
        {this.state.toggleForm ? <AddUser masterData={masterData} callback={this.loadUserList} userlist={this.state.fullData} handler={this.updateToggleFormVal} flag={this.state.toggleForm ? true : false} /> : ''}
        {this.state.toggleAssign ? <AssignUser user={this.individualUser} handler={this.updateToggleAssign} flag={this.state.toggleAssign ? true : false} /> : ''}
        <div className='bread-crumb overflow-auto'>
          <div>
            <span className='breadcrumb-title'>
              <input type='button' className='btn' value='Home - User'></input>
            </span>
            <span className='fr'>
              <input type='button' className='btn btn-success' value='ADD EMPLOYEE' onClick={() => this.addUser()}></input>
            </span>
          </div>
        </div>
        <div className='data-table-holder'>
          <div className='table-search-box'>
            {/* <FontAwesomeIcon icon={faSearch} className='table-icon-inline'/>  */}
            <input type='text' placeholder="Search By Name.." className='form-control' onChange={(e) => this.filterData(e)}></input>
            <input type='text' placeholder="Search By EmpID.." className='form-control' onChange={(e) => this.filterDatabyID(e)}></input>
          </div>
          <DataTable defaultSortFieldId="id"
            columns={this.columns}
            data={this.state.data} pagination striped

          />
        </div>
      </div>
    )
  }
}
